// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.InputArgumentSpec
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
export class InputArgumentSpecBase {
  /** Do NOT invoke directly, instead use strongly typed createInputArgumentSpecBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.InputArgumentSpec";
  }
  initFromJson(json, deserializeContext) {
    this.initInputArgumentSpec(json.defaultValue != null ? json.defaultValue : null, json.isEnabledAsInput, json.isRequired, json.isVector, json.name != null ? json.name : null, json.referencedObjectClass != null ? json.referencedObjectClass : null, json.type != null ? DataFieldTypeEnum.fromJson(json.type) : null);
  }
  initInputArgumentSpec(defaultValue, isEnabledAsInput, isRequired, isVector, name, referencedObjectClass, type) {
    this._defaultValue = defaultValue;
    this._isEnabledAsInput = isEnabledAsInput;
    this._isRequired = isRequired;
    this._isVector = isVector;
    this._name = name;
    this._referencedObjectClass = referencedObjectClass;
    this._type = type;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._defaultValue != null) {
      retVal["defaultValue"] = this._defaultValue;
    }
    retVal["isEnabledAsInput"] = this._isEnabledAsInput;
    retVal["isRequired"] = this._isRequired;
    retVal["isVector"] = this._isVector;
    retVal["name"] = this._name;
    if (this._referencedObjectClass != null) {
      retVal["referencedObjectClass"] = this._referencedObjectClass;
    }
    retVal["type"] = this._type;
    return retVal;
  }
  get defaultValue() {
    return this._defaultValue;
  }
  set defaultValue(value) {
    this._defaultValue = value;
  }
  get isEnabledAsInput() {
    return this._isEnabledAsInput;
  }
  set isEnabledAsInput(value) {
    this._isEnabledAsInput = value;
  }
  get isRequired() {
    return this._isRequired;
  }
  set isRequired(value) {
    this._isRequired = value;
  }
  get isVector() {
    return this._isVector;
  }
  set isVector(value) {
    this._isVector = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get referencedObjectClass() {
    return this._referencedObjectClass;
  }
  set referencedObjectClass(value) {
    this._referencedObjectClass = value;
  }
  get type() {
    return this._type;
  }
  set type(value) {
    this._type = value;
  }
}
//# sourceMappingURL=InputArgumentSpecBase.js.map
